import { render, staticRenderFns } from "./ResidentTable.vue?vue&type=template&id=5450970a&scoped=true&lang=pug"
import script from "./ResidentTable.vue?vue&type=script&lang=ts"
export * from "./ResidentTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentTable.vue?vue&type=style&index=0&id=5450970a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450970a",
  null
  
)

export default component.exports